import React from "react";
import { Container, Row, Col } from 'react-bootstrap';

function LanguageDescription(props) {
  const printBalls = (rank) => {
    const filledBalls = [...Array(Number(rank)).keys()].map(r => <Col><span className="resume-language-ball-filled"></span></Col>);
    filledBalls.push([...Array(5 - Number(rank)).keys()].map(r => <Col><span className="resume-language-ball-not-filled"></span></Col>));
    return filledBalls;
  }

  return (
    <Container className="language-item">
      <Row>
        <Col md={2} style={{ textAlign: "left" }}>
          <p>{props.language}</p>
          <footer className="blockquote-foot">{props.description}</footer>
        </Col>
           {printBalls(props.rank)}
      </Row>
    </Container>
  );
}

export default LanguageDescription;
